module.exports = __webpack_public_path__ + "static/media/logo.f8580f20.svg";